import ClubFeeCategory from './ClubFeeCategory';

export default class ClubSalesListConfig {
    static fromData(data) {
        if (!data) {
            return;
        }

        const clubSalesListConfig = new ClubSalesListConfig();
        clubSalesListConfig.id = data.id;
        clubSalesListConfig.clubFeeCategories = data.clubFeeCategories.map(
            (categoryData) => ClubFeeCategory.fromData(categoryData),
        );
        clubSalesListConfig.paymentMethods = data.paymentMethods.data;

        Object.seal(clubSalesListConfig);
        return clubSalesListConfig;
    }

    serialize() {
        return {
            id: this.id,
            clubFeeCategories: this.clubFeeCategories.map((category) => category.id),
            paymentMethods: this.paymentMethods.map((method) => method.value),
        };
    }
}
